interface Objection {
  label: string;
  title: string;
  desc: string;
}

const OBJECTIONS: Objection[] = [
  {
    label: "No video skills?",
    title: "Doesn't matter.",
    desc: "Dualio handles lip sync, framing, and delivery. You just approve the result.",
  },
  {
    label: "No ring light?",
    title: "Don't need one.",
    desc: "One clear selfie is enough to generate a studio-quality talking head.",
  },
  {
    label: "Can't write scripts?",
    title: "We handle that too.",
    desc: "Paste a TikTok URL and Dualio clones a viral script format for your product.",
  },
];

const Objections = () => (
  <section className="mx-auto mt-16 max-w-3xl px-4 sm:px-6">
    <div className="rounded-3xl border border-brown-200 bg-white p-8 text-center sm:p-12">
      <h2 className="font-extrabold text-2xl text-zinc-900 tracking-tight sm:text-3xl">
        You already have everything you need.
      </h2>
      <p className="mx-auto mt-3 mb-9 max-w-lg text-[15px] text-zinc-500 leading-relaxed">
        No studio. No experience. No excuses. If you have a face and a product — you're
        ready.
      </p>
      <div className="grid gap-5 text-left sm:grid-cols-3">
        {OBJECTIONS.map((o) => (
          <div key={o.label} className="rounded-xl bg-background p-5">
            <p className="mb-2 font-bold text-primary text-xs uppercase tracking-wider">
              {o.label}
            </p>
            <p className="mb-1 font-bold text-sm text-zinc-900">{o.title}</p>
            <p className="text-sm text-zinc-500 leading-relaxed">{o.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Objections;
